module.exports = __webpack_public_path__ + "img/CCF_temp.logo.e3d338aa.png";